module.exports = __webpack_public_path__ + "720a3668d77fe9cf2944f06649465b39.png";